:host {
	display: flex;
	flex-direction: column;
	align-items: center;
}
:host > :first-child {
	margin-top: 0.2rem;
}
